<template>
  <v-card class="blog-post-card" elevation="2" hover @click="$emit('click')">
    <div class="d-flex flex-column flex-sm-row">
      <!-- Thumbnail -->
      <v-img
        v-if="post.headerImage"
        :src="post.headerImage"
        :alt="post.title"
        width="220"
        height="160"
        cover
        class="flex-shrink-0 rounded-ts-lg rounded-bs-lg d-none d-sm-block"
      />

      <div class="flex-grow-1">
        <v-card-text class="pb-2">
          <!-- Category + pinned -->
          <div class="d-flex align-center ga-2 mb-2">
            <v-chip
              :color="post.categoryColor"
              variant="flat"
              size="x-small"
            >
              <v-icon start size="12">{{ post.categoryIcon }}</v-icon>
              {{ $t(`blog.categories.${post.categorySlug}`) }}
            </v-chip>
            <v-chip v-if="post.isPinned" color="amber" variant="flat" size="x-small">
              <v-icon start size="12">mdi-pin</v-icon>
              Fastgjort
            </v-chip>
          </div>

          <!-- Title -->
          <h3 class="text-h6 font-weight-bold mb-1 post-title">{{ post.title }}</h3>

          <!-- Excerpt -->
          <p class="text-body-2 text-grey-darken-1 mb-2 post-excerpt">
            {{ stripHtml(post.excerpt) }}...
          </p>

          <!-- Author + stats -->
          <div class="d-flex align-center flex-wrap ga-3 text-caption text-grey">
            <div class="d-flex align-center ga-1">
              <v-avatar size="22">
                <v-img v-if="post.avatarUrl" :src="post.avatarUrl" />
                <v-icon v-else size="22">mdi-account-circle</v-icon>
              </v-avatar>
              <span>{{ post.displayName || post.username }}</span>
            </div>

            <span>{{ formatDate(post.published_at) }}</span>

            <v-spacer />

            <div class="d-flex align-center ga-3">
              <span>
                <v-icon size="14">mdi-eye</v-icon>
                {{ post.viewCount }}
              </span>
              <span>
                <v-icon size="14">mdi-comment</v-icon>
                {{ post.commentCount }}
              </span>
              <span>
                <v-icon size="14">mdi-heart</v-icon>
                {{ post.reactionCount }}
              </span>
              <span>
                <v-icon size="14">mdi-clock-outline</v-icon>
                {{ post.readTime }} min
              </span>
            </div>
          </div>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>

<script setup>
/* eslint-disable */
defineProps({
  post: { type: Object, required: true }
})

defineEmits(['click'])

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('da-DK', {
    day: 'numeric', month: 'short', year: 'numeric'
  })
}

const stripHtml = (text) => {
  if (!text) return ''
  return text.replace(/<[^>]*>/g, '').substring(0, 200)
}
</script>

<style scoped>
.blog-post-card {
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
}
.blog-post-card:hover {
  transform: translateY(-2px);
}
.post-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.post-excerpt {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>